<template>
  <div class="" dir="ltr">
    <p class="mb-1">نقشه</p>
    <div class="" id="mapcontainer"></div>
  </div>
</template>

<script>
export default {
  props: {
    latitude: {
      type: [String, Number],
    },
    longitude: {
      type: [String, Number],
    },
  },
  data() {
    return {
      map: null,
    };
  },
  mounted() {
    // Vue.nextTick(() => {
    if (this.latitude && this.longitude) {
      this.map = L.map("mapcontainer").setView(
        [this.latitude, this.longitude],
        14
      );
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 19,
        attribution: "© OpenStreetMap",
      }).addTo(this.map);

      // Leaflet has a known issue with wrong marker address
      // This section is their provided solution for fixing the issue
      // Please don't touch it or marker won't be shown on the map
      delete L.Icon.Default.prototype._getIconUrl;
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
        iconUrl: require("leaflet/dist/images/marker-icon.png"),
        shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
      });
      // Solution ends here
      L.marker([this.latitude, this.longitude]).addTo(this.map);
      // });
    }
  },
};
</script>
<style scoped>
#mapcontainer {
  height: 300px;
  width: 100%;
}
/* .leaflet-layer {
  position: absolute;
  left: 0;
  top: 0;
} */
</style>
